<div class="flex-container">
  <mat-checkbox class="allow-skip-checkbox" [formControl]="firstPromptNotSkippable"
    >First prompt cannot be skipped</mat-checkbox
    >
    <div class="ml-auto">
      @if (!autoPlayAll && autoAttendantPromptItems.length > 0) {
        <button
          mat-raised-button
          type="button"
          class="auto-attendant-prompt-play-audio-button"
          (click)="onPlayAllClick()"
          >
          <mat-icon>play_arrow</mat-icon> {{ autoAttendantPromptItems.length === 1 ? 'Play' : 'Play All' }}
        </button>
      }
      @if (autoPlayAll && autoAttendantPromptItems.length > 0) {
        <button
          mat-raised-button
          type="button"
          class="auto-attendant-prompt-play-audio-button"
          (click)="onStopAllClick()"
          >
          <mat-icon>stop</mat-icon> Stop
        </button>
      }
      @if (this.extensionPrivileges?.canEditAutoAttendants) {
        <button
          type="button"
          mat-raised-button
          [matMenuTriggerFor]="createPromptMenu"
          >Add Prompt</button
          >
        }
      </div>
    </div>

    <mat-menu #createPromptMenu>
      <!-- <button type="button" mat-menu-item (click)="onAddClick()">Add New Prompt</button> -->
      @if (this.extensionPrivileges?.canEditAutoAttendants) {
        <button
          type="button"
          mat-menu-item
          (click)="onAddExistingPromptClick()"
          >Add Existing Prompts to Extension</button
          >
        }
        @if (this.extensionPrivileges?.canEditAutoAttendants) {
          <button
            type="button"
            mat-menu-item
            (click)="onAddNewPromptClick(promptTypes.AutoAttendant)"
            >Add New Prompts to Extension</button
            >
          }
        </mat-menu>
        <ul cdkDropList (cdkDropListDropped)="drop($event)" class="prompt-item-list">
          @for (promptItem of autoAttendantPromptItems; track promptItem; let promptArrayIndex = $index) {
            <li
              cdkDrag
              [cdkDragDisabled]="isPaused == false || isLoading"
              (dblclick)="onPlayClick(promptArrayIndex, $event)"
              >
              @if (!promptItem.isDeleted) {
                <div class="prompt-item">
                  <mat-icon class="draggable" aria-label="reorder drag handle" cdkDragHandle>drag_indicator</mat-icon>
                  <span class="item-text">{{ promptItem.prompt.name }}</span>
                  <div class="prompt-actions">
                    @if (promptArrayIndex === currentPlaylistIndex && isLoading == false && showError == false) {
                      <span
                        class="auto-attendant-prompt-now-playing"
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" class="auto-attendant-prompt-equalizer" viewBox="0 0 128 128">
                          <g>
                            @for (index of [0, 1, 2, 3, 4]; track index) {
                              <ng-container>
                                <rect
                           [ngClass]="
                              isPaused ? 'auto-attendant-prompt-bar-paused' : 'auto-attendant-prompt-bar-playing'
                           "
                                  [attr.transform]="'translate(' + index * 20 + ',0)'"
                                  y="15"
                                ></rect>
                              </ng-container>
                            }
                          </g>
                        </svg>
                      </span>
                    }
                    @if (isLoading && promptArrayIndex === currentPlaylistIndex && showError == false) {
                      <div
                        class="prompt-spinner-container"
                        >
                        <mat-spinner class="auto-attendant-prompt-spinner" [diameter]="20"></mat-spinner>
                      </div>
                    }
                    @if (showError && promptArrayIndex === currentPlaylistIndex) {
                      <div
                        class="prompt-error-container"
                        matTooltip="Error playing prompt."
                        >
                        <mat-icon style="color: red"> error_outline </mat-icon>
                      </div>
                    }
                    <button
                      type="button"
                      aria-label="Play/Pause the Selected Prompt"
                      matTooltip="{{ promptArrayIndex === currentPlaylistIndex && isPaused === false ? 'Pause' : 'Play' }}"
                      mat-icon-button
                      [disabled]="disabled"
                      (click)="onPlayClick(promptArrayIndex)"
                      id="auto-attendant-play-prompt-{{ promptArrayIndex }}"
                      >
                      <mat-icon>
                        {{ promptArrayIndex === currentPlaylistIndex && isPaused === false ? 'pause' : 'play_arrow' }}
                      </mat-icon>
                    </button>
                    <button
                      type="button"
                      aria-label="Auto Attendant Prompt Actions"
                      matTooltip="More Actions"
                      mat-icon-button
                      [matMenuTriggerFor]="autoAttendantPromptListItemMenu"
                      [matMenuTriggerData]="{ $implicit: promptItem, index: promptArrayIndex }"
                      [disabled]="disabled"
                      id="auto-attendant-prompt-list-option-menu-button-{{ promptArrayIndex }}"
                      >
                      <mat-icon> more_vert </mat-icon>
                    </button>
                    <mat-menu #autoAttendandtPromptListItemMenu="matMenu">
                      <button mat-menu-item type="button" id="menu-extension-download"> Download </button>
                    </mat-menu>
                  </div>
                </div>
              }
            </li>
          }
          @if (!autoAttendantPromptItems || autoAttendantPromptItems.length === 0) {
            <span>No Prompts Set</span>
          }
        </ul>
        @if (showAudioPlayer) {
          <ndt-audio-playlist-player
            class="auto-attendant-prompt-playlist-player"
            [disabled]="disabled"
            [fileTokens]="fileTokens"
            [autostart]="false"
            >
          </ndt-audio-playlist-player>
        }
        <mat-menu #autoAttendantPromptListItemMenu="matMenu">
          <ng-template matMenuContent let-promptlistItem let-index="index">
            <button type="button" mat-menu-item id="auto-attendant-prompt-list-option-edit-button-listen"
              ><a
              [attr.download]="promptlistItem.prompt.name"
              [attr.href]="promptlistItem.prompt.file?.fileToken | fileUrl"
              class="text-primary"
              >Download</a
              >
            </button>
            @if (this.extensionPrivileges?.canEditAutoAttendants) {
              <button
                type="button"
                mat-menu-item
                id="auto-attendant-prompt-list-option-edit-button-delete"
                (click)="onDeleteClick(index)"
                >
                Delete
              </button>
            }
            <button type="button" mat-menu-item id="mailbox-message-register-option-play" (click)="onPlayClick(index)">
              {{ index === currentPlaylistIndex && isPaused === false ? 'Pause' : 'Play' }}
            </button>
          </ng-template>
        </mat-menu>
